module.exports = __webpack_public_path__ + "brand-img.png?c015da347207c9c20d4ddecfaa02d312";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-img.png
// module id = 24
// module chunks = 0